import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import TicketCategoryForm from './TicketCategoryForm'
import { updateTicketCategory } from '../services'
import { handleError } from '../../../helpers'

export default function EditTicketCategoryModal({ visible, onClose, ticketCategory, reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm()

	const onSubmit = values => {
		if(values.code === ticketCategory.code) delete values.code
		updateTicketCategory(ticketCategory.id, values)
			.then(() => {
				message.success('Categorías actualizada exitosamente.')
				reload()
				reset()
				onClose()
			})
			.catch(error => handleError(error))
	}	

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Categoría de Incidencia</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<TicketCategoryForm ticketCategory={ticketCategory} register={register} errors={errors} />
						<Button type="submit" color="primary">Actualizar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}